import { AnyAction } from 'redux';
import { ReconciliationState } from '../models/reconciliationModel';
import { cloneDeep } from 'lodash';
import actionTypes from '../types/reconciliationTypes';
const initialState: ReconciliationState = {
  insurerName: '',
  tpaId: 0,
  centerId: 0,
  utrDate: null,
  dod: null,
  utrNumber: '',
  searchKey: '',
  viewId: 1,
  columnFilters: [],
  reconciliationDetails: [],
  totalClaimedAmount: 0,
  totalApprovedAmount: 0,
  paidAmount: 0,
  tdsAmount: 0,
  pendingAmount: 0,
  totalSettledClaims: 0,
  totalUTRMappedClaims: 0,
  reconciledClaims: 0,
  shortPaidClaims: 0,
  notPaidClaims: 0,
  lastStatusUpdated: '',
  sortingKey: {},
  statusFilters: [],
  startIndex: 1,
  range: 10,
  reconciliationStatusList: [],
  isTableLoading: true,
  insurerTdsList: [],
  isTdsEditable: false,
  isReconciliationEditable: false,
  updatedReconciliationColsData: [],
  reconciliationClaimDetail: {},
  reconciliationAuditTrail: [],
  manualReconciliationData: [],
  reconciliationLinkedClaims: [],
};

const reducer = (
  state: any = cloneDeep(initialState),
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.UPDATE_RECONCILIATION_COLUMN_FILTERS:
      return {
        ...state,
        columnFilters: action.payload,
      };
    case actionTypes.SET_RECONCILIATION_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.SET_RECONCILIATION_INSURER_FILTER:
      return {
        ...state,
        insurerName: action.payload,
      };
    case actionTypes.SET_RECONCILIATION_TPA_FILTER:
      return {
        ...state,
        tpaId: action.payload,
      };
    case actionTypes.SET_RECONCILIATION_CENTER_FILTER:
      return {
        ...state,
        centerId : action.payload,
      };
    case actionTypes.SET_RECONCILIATION_DOD_FILTER:
      return {
        ...state,
        dod : action.payload,
      };
    case actionTypes.SET_RECONCILIATION_UTR_DATE_FILTER:
      return {
        ...state,
        utrDate : action.payload,
      };
    case actionTypes.SET_RECONCILIATION_UTR_NUMBER_FILTER:
      return {
        ...state,
        utrNumber : action.payload,
      };
    case actionTypes.SET_RECONCILIATION_SEARCH_FILTER:
      return {
        ...state,
        searchKey: action.payload,
      };
    case actionTypes.SET_RECONCILIATION_VIEW_ID:
      return {
        ...state,
        viewId: action.payload,
      };
    case actionTypes.SET_RECONCILIATION_SORTING_KEY:
      return {
        ...state,
        sortingKey: action.payload,
      };
    case actionTypes.SET_RECONCILIATION_CLAIM_STATUSES:
      return {
        ...state,
        reconciliationStatusList: action.payload,
      };
    case actionTypes.SET_RECONCILIATION_START_INDEX:
      return {
        ...state,
        startIndex: action.payload,
      };
    case actionTypes.SET_RECONCILIATION_PAGE_RANGE:
      return {
        ...state,
        range: action.payload,
      };
    case actionTypes.SET_IS_TABLE_LOADING:
      return {
        ...state,
        isTableLoading: action.payload,
      };
    case actionTypes.SET_IS_TDS_EDITABLE:
      return{
        ...state,
        isTdsEditable: action.payload,
      };
    case actionTypes.SET_INSURER_WISE_TDS_RATES:
      return{
        ...state,
        insurerTdsList: action.payload,
      };
    case actionTypes.SET_IS_RECONCILIATION_EDITABLE:
      return{
        ...state,
        isReconciliationEditable: action.payload,
      };
    case actionTypes.UPDATED_RECONCILIATION_COLS_DATA:
      return{
        ...state,
        updatedReconciliationColsData: action.payload,
      };
    case actionTypes.SET_RECONCILIATION_CLAIM_DETAIL:
      return{
        ...state,
        reconciliationClaimDetail: action.payload,
      };
    case actionTypes.SET_RECONCILIATION_DETAIL:
      return{
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export { reducer as reconciliationReducer };
